// import React, { useState } from 'react';
// import Button from "@material-ui/core/Button";
// import AgencyRegistrationForm from './AgencyRegistrationForm';
// import AgentRegistrationForm from './AgentRegistrationForm';
// import './style.css';
// import Header from '../../components/header';

// const BrokerRegistrationPage = () => {
//     const [registrationType, setRegistrationType] = useState('agency');
//     const [step, setStep] = useState(1);
    
//     const handleTypeChange = (type) => {
//         setRegistrationType(type);
//     };

//     return (
//         <>
//             {/* Header with Navigation */}
//             <Header />
            
//             {/* Main Registration Content */}
//             <div className="broker-registration-section">
//                 <div className="container">
//                     <div className="row justify-content-center">
//                         <div className="col-lg-10 col-md-12 col-sm-12">
//                             <div className="broker-registration-wrapper">
//                                 {step === 1 ? (
//                                     <div className="registration-selection-step">
//                                         {/* Company Logo Section */}
//                                         {/* <div className="company-logo-section">
//                                             <div className="logo-container">
//                                                 <Link to="/" onClick={ClickHandler}>
//                                                     <img src={Logo} alt="MaakDream Developers" className="company-logo" />
//                                                 </Link>
//                                             </div>
//                                             <div className="logo-divider"></div>
//                                         </div> */}
                                        
//                                         <div className="section-title text-center">
//                                             <div className="title-icon">
//                                                 <i className="fi ti-briefcase"></i>
//                                             </div>
//                                             <h2>Choose Your Registration Type</h2>
//                                             <p>Join our network of trusted partners and grow your business with MaakDream Developers</p>
//                                         </div>
                                        
//                                         <div className="registration-type-selection">
//                                             <div 
//                                                 className={`registration-option ${registrationType === 'agency' ? 'active' : ''}`}
//                                                 onClick={() => handleTypeChange('agency')}
//                                             >
//                                                 <div className="option-content">
//                                                     <h3>Agency</h3>
//                                                     <p>Register your real estate agency to access exclusive properties and client leads</p>
//                                                     <div className="check-icon">
//                                                         {registrationType === 'agency' && <i className="fi ti-check"></i>}
//                                                     </div>
//                                                 </div>
//                                             </div>
                                            
//                                             <div 
//                                                 className={`registration-option ${registrationType === 'agent' ? 'active' : ''}`}
//                                                 onClick={() => handleTypeChange('agent')}
//                                             >
//                                                 <div className="option-content">
//                                                     <h3>Individual</h3>
//                                                     <p>Register as an individual agent to start your career in real estate</p>
//                                                     <div className="check-icon">
//                                                         {registrationType === 'agent' && <i className="fi ti-check"></i>}
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
                                        
//                                         <div className="registration-buttons">
//                                             <Button 
//                                                 className="theme-btn"
//                                                 onClick={() => setStep(2)}
//                                             >
//                                                 Continue Registration
//                                                 <i className="fi ti-arrow-right"></i>
//                                             </Button>
//                                         </div>
// {/* 
//                                         <div className="registration-benefits">
//                                             <h4>Why Register with Us?</h4>
//                                             <div className="benefits-grid">
//                                                 <div className="benefit-item">
//                                                     <div className="benefit-icon">
//                                                         <i className="fi flaticon-house"></i>
//                                                     </div>
//                                                     <h5>Exclusive Properties</h5>
//                                                     <p>Access to premium properties before they hit the market</p>
//                                                 </div>
//                                                 <div className="benefit-item">
//                                                     <div className="benefit-icon">
//                                                         <i className="fi flaticon-support"></i>
//                                                     </div>
//                                                     <h5>24/7 Support</h5>
//                                                     <p>Round-the-clock support for all your queries and needs</p>
//                                                 </div>
//                                                 <div className="benefit-item">
//                                                     <div className="benefit-icon">
//                                                         <i className="fi flaticon-chart"></i>
//                                                     </div>
//                                                     <h5>High Commission</h5>
//                                                     <p>Competitive commission rates and bonus incentives</p>
//                                                 </div>
//                                             </div>
//                                         </div> */}
//                                     </div>
//                                 ) : (
//                                     <div className="registration-form-step">
//                                         {registrationType === 'agency' ? 
//                                             <AgencyRegistrationForm onPrevious={() => setStep(1)} /> : 
//                                             <AgentRegistrationForm onPrevious={() => setStep(1)} />
//                                         }
//                                     </div>
//                                 )}
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     );
// };

// export default BrokerRegistrationPage;






















import React, { useState, useEffect } from 'react';
import Button from "@material-ui/core/Button";
import AgencyRegistrationForm from './AgencyRegistrationForm';
import AgentRegistrationForm from './AgentRegistrationForm';
import './style.css';
import Header from '../../components/header';
import { getBrokerRegistration } from '../../api/BrokerRegistration';

const BrokerRegistrationPage = () => {
    const [registrationType, setRegistrationType] = useState('agency');
    const [step, setStep] = useState(1);
    const [data, setData] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            const res = await getBrokerRegistration();
            setData(res);
        };
        fetchData();
    }, []);

    const handleTypeChange = (type) => {
        setRegistrationType(type);
    };

    if (!data) return <p>Loading...</p>; // Simple loading state

    return (
        <>
            <Header />
            <div className="broker-registration-section">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10 col-md-12 col-sm-12">
                            <div className="broker-registration-wrapper">
                                {step === 1 ? (
                                    <div className="registration-selection-step">
                                        <div className="section-title text-center">
                                            <div className="title-icon">
                                                <i className="fi ti-briefcase"></i>
                                            </div>
                                            <h2>{data.title}</h2>
                                            <p>{data.subtitle}</p>
                                        </div>
                                        
                                        <div className="registration-type-selection">
                                            {data.bregistration.map((card, index) => (
                                                <div 
                                                    key={index}
                                                    className={`registration-option ${registrationType === (card.card_title.toLowerCase()) ? 'active' : ''}`}
                                                    onClick={() => handleTypeChange(card.card_title.toLowerCase())}
                                                >
                                                    <div className="option-content">
                                                        <h3>{card.card_title}</h3>
                                                        <p>{card.card_subtitle}</p>
                                                        <div className="check-icon">
                                                            {registrationType === card.card_title.toLowerCase() && <i className="fi ti-check"></i>}
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        
                                        <div className="registration-buttons">
                                            <Button 
                                                className="theme-btn"
                                                onClick={() => setStep(2)}
                                            >
                                                {data.btn_text}
                                                <i className="fi ti-arrow-right"></i>
                                            </Button>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="registration-form-step">
                                        {registrationType === 'agency' ? 
                                            <AgencyRegistrationForm onPrevious={() => setStep(1)} /> : 
                                            <AgentRegistrationForm onPrevious={() => setStep(1)} />
                                        }
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BrokerRegistrationPage;
